import React, { useEffect, useState } from "react";
import { Col, Row, Container } from "reactstrap";
import { Loader } from "../../components";
import { getLocalization } from "../../redux/localization";
import { useDispatch, useSelector } from "react-redux";
import { getFaqs } from "../../redux/homepage/saga";
import { Helmet } from "react-helmet";
import { FaqsDto } from "../../redux/system/type";
import Question from "./faqCard";
import "./style.scss";
import { useLocation } from "react-router-dom";
import images from "../../assets/images";
import { appUrl } from "../../redux/base/types/url";
import { languageSelector, languagesSelector } from "../../redux/languages";

const HelpPage = () => {
  const [loader, setLaoder] = useState(false);
  const t = useSelector(getLocalization);
  const dispatch = useDispatch();
  const [faqs, setFaqs] = useState<FaqsDto[]>([]);
  const [searchfaqs, setSearchFaqs] = useState<FaqsDto[]>([]);
  useEffect(() => {
    setLaoder(true);
    dispatch(
      getFaqs({
        payload: {
          onSuccess: (message, payload) => {
            setFaqs(payload);
            setSearchFaqs(payload);
            return setLaoder(false);
          },
          onError: () => {
            return setLaoder(false);
          },
        },
      })
    );
  }, [dispatch]);
  const language = useSelector(languageSelector);
  const location = useLocation();
  const title = t.getString("HelpSeoTitle");
  const desc = t.getString("HelpSeoDescription");
  const languages = useSelector(languagesSelector);
  return (
    <React.Fragment>
      <Helmet>
        <title>{title}</title>{" "}
        {/* <link rel="alternate" hrefLang="x-default" href={appUrl + "/help"} /> */}
        {/* {languages.map((x) => {
          let code = x.Code.split("-")[0];
          return (
            <link
              rel={code === "en" ? "canonical" : "alternate"}
              hrefLang={code}
              href={appUrl + "/" + code + "/help"}
            />
          );
        })} */}
        <meta name="title" content={title} />
        <meta name="description" content={desc} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={desc} />
        <meta name="twitter:image" content={title} />
        <meta name="twitter:card" content={"large_summary_card"} />
        <meta name="twitter:site" content="@rentificial" />
        <meta name="twitter:creator" content="@rentificial" />
        <meta property="og:title" content={title} />
        <meta property="og:type" content="website" />
        <meta property="og:description" content={desc} />
        <meta property="og:image" content={images.logoColored} />
        <meta property="og:url" content={appUrl +  location.pathname} />
        <link  rel="canonical"  href="https://www.rentificial.com/help/"/>

      </Helmet>
      <Container>
        {loader && <Loader />}
        <div className="page-content defaultPage">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <h1>Welcome to the Rentificial Help Center 👋<br /></h1>
            <p style={{ textAlign: "left", maxWidth: "50%" }}>
  
  Whether you're just getting started or you're looking for advanced tips to
  optimize your <strong>car rental software</strong> experience, you're in the
  right place. Browse our FAQs for quick solutions or get in touch with our team
  for personal support anytime. We’re here to help your rental business grow 🚀
</p>

            <a
              className="primaryButton mt-2"
              style={{ width: 300, textAlign: "center" }}
              href={"/contactus"}
              target={"_blank"}
              rel="noreferrer"
            >
              {t.getString("Contact Us")}
            </a>
            <form className="app-search d-lg-block mt-4">
              <div className="position-relative">
                <input
                  type="text"
                  style={{
                    background: "#f3f3f9",
                    color: "#495057",
                  }}
                  className="form-control"
                  placeholder=""
                  onChange={(e) => {
                    if (e.target.value) {
                      setFaqs(
                        searchfaqs.filter(
                          (x) =>
                            x.Question.toLocaleLowerCase().includes(
                              e.target.value.toLocaleLowerCase()
                            ) ||
                            x.Answer.toLocaleLowerCase().includes(
                              e.target.value.toLocaleLowerCase()
                            )
                        )
                      );
                    } else {
                      setFaqs(searchfaqs);
                    }
                  }}
                />
                <button
                  className=" btn btn-primary"
                  style={{ background: "#2e78bc" }}
                  type="button"
                >
                  <i className="bx bx-search-alt align-middle"></i>
                </button>
              </div>
            </form>
          </div>

          <Row className="mt-5">
            {faqs.map((x, i) => (
              <Col key={x.Id} xl={4} sm={6}>
                <Question faq={x} index={i} />
              </Col>
            ))}
          </Row>
          <Col md={12} className="mt-5 text-left">
  <div style={{ backgroundColor: '#f8f9fa', padding: '24px', borderRadius: '8px' }}>
    <h3 style={{ fontWeight: 'bold' }}>Still Have Questions? We're Just a Message Away.</h3>
    <p className="text-left">
      At Rentificial, we understand that every rental business is unique, and sometimes your needs go beyond the frequently asked questions.
      That’s why we’re always here to provide personal support when you need it most. Whether you’re unsure about a specific feature, need technical guidance, or simply want to understand how our car rental software can better fit your workflow, our team is just one click away.
      <br /><br />
      Don’t hesitate to reach out through our contact form or send us an email directly. We usually respond within 24 hours — often much faster. Your success is our priority, and we’re committed to making your rental operations easier, smarter, and more scalable.
      <br /><br />
      Also, don’t forget to check out our blog and product guides for tips, updates, and how-to tutorials. We regularly publish insights to help you stay ahead of the curve and get the most out of Rentificial.
      <br /><br />
      Need something specific? Let us know — we’d love to hear from you and help however we can.
    </p>
  </div>
</Col>
        </div>
      </Container>
    </React.Fragment>
  );
};
export default HelpPage;
